import { useCallback, useContext, useEffect, useState } from "react";
import { ContextStatus } from "@leedpulse-monorepo/enums";
import { Dayjs } from "dayjs";
import listVoipCalls, { VoipCallFilters, VoipCallRow } from "../../../domain/use_cases/leedflow/voipCalls/listVoipCalls";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";

export const useVoipCalls = (
    period?: [Dayjs | null, Dayjs | null],
    filters?: VoipCallFilters,
) => {
    const authContext = useContext(AuthenticationContext);
    const auth = authContext.authentication;

    const [calls, setCalls] = useState<VoipCallRow[]>([]);
    const [status, setStatus] = useState<ContextStatus>(ContextStatus.IDLE);

    const load = useCallback(async () => {
        if (!auth) return;
        setStatus(ContextStatus.LOADING);
        try {
            const res = await listVoipCalls(auth, period, filters);
            setCalls(res);
            setStatus(ContextStatus.SUCCESS);
        } catch (error) {
            console.error(error);
            setStatus(ContextStatus.ERROR);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, period, JSON.stringify(filters)]);

    useEffect(() => {
        load();
    }, [load]);

    return { calls, status, reload: load };
};
